const apiUrl = "https://server.irisfinejewels.com";
function formatPrice(price) {
  if (isNaN(price)) {
    return "";
  }
  const parts = price.toFixed(2).toString().split(".");
  if (parseInt(parts[1]) !== 0) {
    return parts.join(".");
  }
  return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function calculatePrice() {
  const selectedCarat = $('input[name="properties[Carat]"]:checked').val();
  const selectedRing = $('input[name="properties[Ring]"]:checked').val();
  const selectedClarity = $('input[name="properties[clarity]"]:checked').val();
  const selectedDiaColor = $(
    'input[name="properties[DIA Color]"]:checked'
  ).val();
  const netWeight = $("#product-info").data("netweight");

  const quantity = $('input[name="quantity"]').val();
  const checkedInputValue = $('input[name="Shop With Diamonds"]:checked').val();
  const design =
    (checkedInputValue ? checkedInputValue.toLowerCase() : null) ||
    $("#product-info").data("diamond-shape") ||
    "";

  $(".diamondShape").text(design);

  const design_number = $("#product-info").data("design-number");

  const smallDiamondWieghtInCarat = $("#small-diamond-pc").text();
  const productType = $("#product-info").data("type").toLowerCase();
  const necklace_bracelet_diamond_weight = $("#product-info").data(
    "necklace-bracelet-diamond-weight"
  );
  const length = $('input[name="properties[necklace]"]:checked').val();
  const goldCarat = $("#product-info").data("gold-carat");

  $("#caratWightId").text(selectedCarat);
  const queryParams = {
    clarity:
      productType.includes("ring") ||
      productType.includes("pendant") ||
      productType.includes("earring")
        ? selectedClarity.toLowerCase()
        : "VVS-VS",
    color:
      productType.includes("ring") ||
      productType.includes("pendant") ||
      productType.includes("earring")
        ? selectedDiaColor
        : "E-F",
    ...((productType.includes("ring") ||
      productType.includes("pendant") ||
      productType.includes("earring")) && {
      carat: selectedCarat,
    }),
    ...((productType.includes("necklace") ||
      productType.includes("bracelet")) && {
      carat: necklace_bracelet_diamond_weight,
      necklaceBraceletLength: length,
    }),
    netWeight: netWeight ? netWeight : 1,
    smallDiamondWeight: smallDiamondWieghtInCarat
      ? smallDiamondWieghtInCarat
      : 0,
    design: design ? design : "fancy",
    quantity,
    category: productType,
    designNumber: design_number,
    goldCarat: goldCarat ? goldCarat : 18,
  };

  let divCaratWt = queryParams.carat / 5;
  let selctedcartVal = queryParams.carat;
  $("#cartWeight").text(divCaratWt);
  $(".cstmaddContent").text(selctedcartVal);
  $.ajax({
    url: `${apiUrl}/api/v2/productprice` + "?" + $.param(queryParams),
    type: "GET",
    dataType: "json",
    success: function (data) {
      $("#live-gold-price").text(formatPrice(data.liveGoldPrice));
      $("#weight-price").text(formatPrice(data.gold));
      $("#gold-making").text(formatPrice(data.goldMaking));
      $("#per-carat-price").text(formatPrice(data.caratPrice));
      $("#per-carat-total").text(formatPrice(data.bigDiamondPrice));
      $("#sub-total").text(formatPrice(data.subTotal));
      $("#gst-total").text(formatPrice(data.gst));
      $("#grand-total").text(formatPrice(data.finalPrice));
      $("#variance").text(data.variance);
      $("#small-per-carat-total").text(formatPrice(data.smallDiamondPrice));
      $("#priceWithQuantity").text(formatPrice(data.priceWithQuantity));
      $("#sku_modified").text(data.sku);
      $(".netWeight").text(data.netWeight);
      $(".grosWeight").text(data.grossWeight);
      if (
        productType.includes("necklace") ||
        productType.includes("bracelet")
      ) {
        $(".cstmaddContent").text(data.carat);
      }
      $('#gold_carat').text(data.goldCarat);
    },

    error: function (jqXHR, textStatus, errorThrown) {
      console.log("Error-----:", textStatus, errorThrown);
    },
  });
}
$(document).ready(function () {
  // Set initial values on load
  $("#selected_carat").val($('input[name="properties[Carat]"]:checked').val());
  // Corrected ID to selected_ring_size to match HTML
  $("#selected_ring_size").val($('input[name="properties[Ring]"]:checked').val()); 
  // Added initial values for Clarity and DIA Color
  $("#selected_clarity").val($('input[name="properties[clarity]"]:checked').val());
  $("#selected_dia_color").val($('input[name="properties[DIA Color]"]:checked').val());

  calculatePrice();
  
  // ======================common price chnag========
  $(".variantSlctval").change(function () {
    calculatePrice();
  });

  $('input[name="quantity"]').change(function () {
    calculatePrice();
  });

  // Carat change handler
  $('input[name="properties[Carat]"]').change(function () {
    $("#selected_carat").val(
      $('input[name="properties[Carat]"]:checked').val()
    );
    $(".carat-options").toggle();
  });
  
  // Necklace change handler
  $('input[name="properties[necklace]"]').change(function () {
    $("#selected_necklace").val(
      $('input[name="properties[necklace]"]:checked').val()
    );
    $(".necklace-options").toggle();
  });
  
  // Ring change handler
  $('input[name="properties[Ring]"]').change(function () {
    $("#selected_ring_size").val($('input[name="properties[Ring]"]:checked').val());
    $(".ring-options").toggle();
  });

  // Added Clarity change handler
  $('input[name="properties[clarity]"]').change(function () {
    $("#selected_clarity").val(
      $('input[name="properties[clarity]"]:checked').val()
    );
    $(".clarity-options").toggle();
  });

  // Added DIA Color change handler
  $('input[name="properties[DIA Color]"]').change(function () {
    $("#selected_dia_color").val(
      $('input[name="properties[DIA Color]"]:checked').val()
    );
    $(".dia-color-options").toggle();
  });


  // Carat Options Show/Hide
  $(".carat-select-btn").click(function () {
    $(".carat-options").toggle();
  });
  
  // necklace Options Show/Hide
  $(".necklace-select-btn").click(function () {
    $(".necklace-options").toggle();
  });

  // Ring Options Show/Hide
  $(".ring-select-btn").click(function () {
    $(".ring-options").toggle();
  });

  // Added Clarity Options Show/Hide
  $(".clarity-select-btn").click(function () {
    $(".clarity-options").toggle();
  });

  // Added DIA Color Options Show/Hide
  $(".dia-color-select-btn").click(function () {
    $(".dia-color-options").toggle();
  });
  
  // ================================show message=======================
  $(".hovercategory").hover(function () {
    $(this).find(".shwtxtvrnt").toggleClass("mouseenter");
  });
  // =========================================================================
  
  // Updated outside click handler to include Clarity and DIA Color
  $("body").on("click", function (e) {
    if (!$(e.target).closest(".caratSelectOptiop").length) {
      $(".carat-options").hide();
    }
    if (!$(e.target).closest(".ringSelectOptiop").length) {
      $("ul#ring-options").hide();
    }
    if (!$(e.target).closest(".claritySelectOptiop").length) {
      $(".clarity-options").hide();
    }
    if (!$(e.target).closest(".dia-colorSelectOptiop").length) {
      $(".dia-color-options").hide();
    }
  });

  function productExist(productHandle) {
    let count = 0;
    fetch(`/products/${productHandle}.js`)
    .then((response) => response.json())
    .then(data => {
        count++
    })
    .catch(error => {
        console.error('Error:', error);
    });
    return count;
  }

  const productHandle = $("#product-info").data("handle");
  //Gold Color Options Visibility
  if (!productHandle.includes("yellow-gold") && !productHandle.includes("rose-gold") && !productHandle.includes("white-gold")) {
    $(".cstnvarientpar").hide();
  }
  // else {
  //   const [baseName, material] = productHandle.split('-');
  //   const relatedMaterials = ['white-gold', 'yellow-gold', 'rose-gold'];
  //   const relatedProductHandles = [];
  //   relatedMaterials.forEach((relatedMaterial) => {
  //       if (relatedMaterial !== material) {
  //           const relatedHandle = `${baseName}-${relatedMaterial}`;
  //           relatedProductHandles.push(relatedHandle);
  //       }
  //   });

  //   relatedProductHandles.forEach((handle, index) => {
  //       if(productExist(handle) == 0){
  //         if(handle.includes('white-gold')){
  //           $('.cstnvarientpar varientColor:nth-child(3)').hide();
  //         }
  //         if(handle.includes('yellow-gold')){
  //           $('.cstnvarientpar varientColor:nth-child(1)').hide();
  //         }
  //         if(handle.includes('rose-gold')){
  //           $('.cstnvarientpar varientColor:nth-child(2)').hide();
  //         }
  //       }
  //   });
  // }
  
});

// ======================================add to cart =========================================
function addToCart() {
  document.getElementById("addtoCartloader").style.display = "flex";

  const selectedCarat = $('input[name="properties[Carat]"]:checked').val();
  const selectedNecklacest = $(
    'input[name="properties[Necklaces]"]:checked'
  ).val();
  const selectedBracelets = $(
    'input[name="properties[Bracelets]"]:checked'
  ).val();
  const selectedRing = $('input[name="properties[Ring]"]:checked').val();
  const selectedClarity = $('input[name="properties[clarity]"]:checked').val();
  const selectedDiaColor = $(
    'input[name="properties[DIA Color]"]:checked'
  ).val();
  const url = `${apiUrl}/api/v1/addtocart`;
  const productHandle = $("#product-info").data("handle");
  const productTitle = $("#product-info").data("title");
  const productType = $("#product-info").data("type").toLowerCase();

  const quantity = $('input[name="quantity"]').val();
  const netWeight = $("#product-info").data("netweight");

  const design = $('input[name="Shop With Diamonds"]:checked').val()
    ? $('input[name="Shop With Diamonds"]:checked').val().toLowerCase()
    : "";
  const smallDiamondWieghtInCarat = $("#small-diamond-pc").text();
  const necklace_bracelet_diamond_weight = $("#product-info").data(
    "necklace-bracelet-diamond-weight"
  );

  const imageUrl = "https:" + $("#product-info").data("img-url");

  const design_number = $("#product-info").data("design-number");
  const length = $('input[name="properties[necklace]"]:checked').val();
  const goldCarat = $("#product-info").data("gold-carat");

  const productData = {
    clarity:
      productType.includes("ring") ||
      productType.includes("pendant") ||
      productType.includes("earring")
        ? selectedClarity.toLowerCase()
        : "VVS-VS",
    color:
      productType.includes("ring") ||
      productType.includes("pendant") ||
      productType.includes("earring")
        ? selectedDiaColor
        : "E-F",
    ...((productType.includes("ring") ||
      productType.includes("pendant") ||
      productType.includes("earring")) && {
      carat: selectedCarat,
    }),
    ...((productType.includes("necklace") ||
      productType.includes("bracelet")) && {
      carat: necklace_bracelet_diamond_weight,
      necklaceBraceletLength: length,
    }),
    netWeight: netWeight ? netWeight : 1,
    smallDiamondWeight: smallDiamondWieghtInCarat
      ? smallDiamondWieghtInCarat
      : 0,
    design: design ? design : "round",
    productHandle,
    productTitle,
    quantity,
    category: productType,
    imageUrl,
    designNumber: design_number,
    goldCarat: goldCarat ? goldCarat : 18,
  };

  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(productData),
  };

  fetch(url, requestOptions)
    .then((response) => response.json())
    .then((data) => {
      fetch(`/cart/add.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: [
            {
              id: data.variant,
              quantity: quantity,
              properties: {
                Clarity:
                  productType.includes("ring") ||
                  productType.includes("pendant") ||
                  productType.includes("earring")
                    ? selectedClarity.toLowerCase()
                    : "VVS-VS",
                Color:
                  productType.includes("ring") ||
                  productType.includes("pendant") ||
                  productType.includes("earring")
                    ? selectedDiaColor
                    : "E-F",
                "Net Weight": data.netWeight,
                ...(smallDiamondWieghtInCarat && {
                  "Small Diamond Weight": smallDiamondWieghtInCarat,
                }),
                ...((productType.includes("ring") ||
                  productType.includes("pendant") ||
                  productType.includes("earring")) && {
                  Carat: selectedCarat,
                }),
                ...((productType.includes("necklace") ||
                  productType.includes("bracelet")) && {
                  Length: length,
                }),
                Design: design ? design : "Round",
                ...(productType.includes("ring") && {
                  Ring: selectedRing,
                }),
              },
            },
          ],
        }),
      }).then(() => {
        document.getElementById("addtoCartloader").style.display = "none";
        window.location.href = "/cart";
      });
    })
    .catch((error) => {
      document.getElementById("addtoCartloader").style.display = "none";
      console.error("Error:", error);
    });
}

// ============================buy now ===============================================

async function buyNowToCheck() {
  document.getElementById("buyNowloader").style.display = "flex";

  const selectedCarat = $('input[name="properties[Carat]"]:checked').val();
  const selectedNecklacest = $(
    'input[name="properties[Necklaces]"]:checked'
  ).val();
  const selectedBracelets = $(
    'input[name="properties[Bracelets]"]:checked'
  ).val();
  const selectedRing = $('input[name="properties[Ring]"]:checked').val();
  const selectedClarity = $('input[name="properties[clarity]"]:checked').val();
  const selectedDiaColor = $(
    'input[name="properties[DIA Color]"]:checked'
  ).val();
  const url = `${apiUrl}/api/v1/addtocart`;
  const productHandle = $("#product-info").data("handle");
  const productTitle = $("#product-info").data("title");
  const productType = $("#product-info").data("type").toLowerCase();

  const quantity = $('input[name="quantity"]').val();
  const netWeight = $("#product-info").data("netweight");

  const design = $('input[name="Shop With Diamonds"]:checked').val()
    ? $('input[name="Shop With Diamonds"]:checked').val().toLowerCase()
    : "";
  const smallDiamondWieghtInCarat = $("#small-diamond-pc").text();
  const necklace_bracelet_diamond_weight = $("#product-info").data(
    "necklace-bracelet-diamond-weight"
  );

  const imageUrl = "https:" + $("#product-info").data("img-url");

  const design_number = $("#product-info").data("design-number");
  const length = $('input[name="properties[necklace]"]:checked').val();

  const productData = {
    clarity:
      productType.includes("ring") ||
      productType.includes("pendant") ||
      productType.includes("earring")
        ? selectedClarity.toLowerCase()
        : "VVS-VS",
    color:
      productType.includes("ring") ||
      productType.includes("pendant") ||
      productType.includes("earring")
        ? selectedDiaColor
        : "E-F",
    ...((productType.includes("ring") ||
      productType.includes("pendant") ||
      productType.includes("earring")) && {
      carat: selectedCarat,
    }),
    ...((productType.includes("necklace") ||
      productType.includes("bracelet")) && {
      carat: necklace_bracelet_diamond_weight,
      necklaceBraceletLength: length,
    }),
    netWeight: netWeight ? netWeight : 1,
    smallDiamondWeight: smallDiamondWieghtInCarat
      ? smallDiamondWieghtInCarat
      : 0,
    design: design ? design : "round",
    productHandle,
    productTitle,
    quantity,
    category: productType,
    imageUrl,
    designNumber: design_number,
  };

  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(productData),
  };

  fetch(url, requestOptions)
    .then((response) => response.json())
    .then((data) => {
      fetch(`/cart/add.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: [
            {
              id: data.variant,
              quantity: quantity,
              properties: {
                Clarity:
                  productType.includes("ring") ||
                  productType.includes("pendant") ||
                  productType.includes("earring")
                    ? selectedClarity.toLowerCase()
                    : "VVS-VS",
                Color:
                  productType.includes("ring") ||
                  productType.includes("pendant") ||
                  productType.includes("earring")
                    ? selectedDiaColor
                    : "E-F",
                "Net Weight": data.netWeight,
                ...(smallDiamondWieghtInCarat && {
                  "Small Diamond Weight": smallDiamondWieghtInCarat,
                }),
                ...((productType.includes("ring") ||
                  productType.includes("pendant") ||
                  productType.includes("earring")) && {
                  Carat: selectedCarat,
                }),
                ...((productType.includes("necklace") ||
                  productType.includes("bracelet")) && {
                  Length: length,
                }),
                Design: design ? design : "Round",
                ...(productType.includes("ring") && {
                  Ring: selectedRing,
                }),
              },
            },
          ],
        }),
      }).then(() => {
        document.getElementById("buyNowloader").style.display = "none";
        window.location.href = "/checkout";
      });
    })
    .catch((error) => {
      document.getElementById("buyNowloader").style.display = "none";
      console.error("Error:", error);
    });
}
// Show loader
//   document.getElementById("buyNowloader").style.display = "flex";

//   try {
//     const selectedCarat = $('input[name="properties[Carat]"]:checked').val();
//     const selectedBracelets = $(
//       'input[name="properties[Bracelets]"]:checked'
//     ).val();
//     const selectedNecklaces = $(
//       'input[name="properties[Necklaces]"]:checked'
//     ).val();
//     const selectedRing = $('input[name="properties[Ring Size]"]:checked').val();
//     const selectedClarity = $(
//       'input[name="properties[clarity]"]:checked'
//     ).val();
//     const selectedDiaColor = $(
//       'input[name="properties[DIA Color]"]:checked'
//     ).val();
//     const productHandle = $("#product-info").data("handle");
//     const productTitle = $("#product-info").data("title");
//     const quantity = $('input[name="quantity"]').val();
//     const netWeight = $("#nettWeight").text();

//     const url = "/cart/add.js"; // Adjust the URL as needed

//     const productData = {
//       id: productHandle,
//       quantity: quantity,
//       properties: {
//         Carat: selectedCarat,
//         Clarity: selectedClarity ? selectedClarity.toLowerCase() : "vvs1",
//         Color: selectedDiaColor,
//         "Net Weight": 0.85,
//         "Small DiamondWeight": 0,
//         Design: "round",
//         "Ring Size": selectedRing,
//       },
//     };

//     const requestOptions = {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify(productData),
//     };

//     const response = await fetch(url, requestOptions);
//     const data = await response.json();

//     // Redirect to checkout after adding to cart
//     window.location.href = "/checkout";
//   } catch (error) {
//     console.error("Error:", error);
//   } finally {
//     // Hide buyNowloader after the entire process is completed
//     document.getElementById("buyNowloader").style.display = "none";
//   }
// }
// ============================end buy now ============================================

// ================================end show message=======================

// Function to get the selected value from localStorage
function getSelectedValue() {
  return localStorage.getItem("selectedCaratValue");
}

// Function to set the selected value in localStorage
function setSelectedValue(value) {
  localStorage.setItem("selectedCaratValue", value);
}
// ===========================necklace length ========================================

function getSelectedValue() {
  return localStorage.getItem("selectednecklacetValue");
}

function setSelectedValue(value) {
  localStorage.setItem("selectednecklaceValue", value);
}
// ===========================end necklace length ========================================

$(".option").click(function () {
  $(this).addClass("activeradio");
  $(this).siblings().removeClass("activeradio");
});
$(".optionradiobtn").click(function () {
  $(".productVariPopup").removeClass("ShowvarPopuppar");
  $(".productVariPopupul").removeClass("ShowvarPopup");
});

// ==============================ring view more option js============
$(".viwMrRngOptn").click(function () {
  $(".productVariPopupul").addClass("ShowvarPopup");
  $(".productVariPopup").addClass("ShowvarPopuppar");
});
$(".clsppupbtn").click(function () {
  $(".productVariPopupul").removeClass("ShowvarPopup");
  $(".productVariPopupul").hide();
  $(".productVariPopup").removeClass("ShowvarPopuppar");
});

$(".ring-size-radio-label").click(function () {
  $(".productVariPopupul").removeClass("ShowvarPopup");
  $(".productVariPopup").removeClass("ShowvarPopuppar");
});
$(".faqsidelink").click(function () {
  $(".productVariPopupul").removeClass("ShowvarPopup");
  $(".productVariPopup").removeClass("ShowvarPopuppar");
  $(".ring-select-menu").removeClass("active");
});